export const addressInputFields = {
    "postalcode": "Почтовый индекс",
    "country": "Страна",
    "republic": "Республика",
    "territory": "Край",
    "region": "Область",
    "districts": "Район",
    "locality": "Населённый пункт",
    "street": "Улица",
    "houseNumber": "Номер дома(здания)",
    "building": "Корпус",
    "roomType": "Тип помещения",
    "roomNumber": "Номер помещения",
    "latitude": "Широта",
    "longitude": "Долгота",
    "additionalInfo": "Дополнительная информация",
};

export const addressInputActionPlaceholders = {
    postalcode: "Введите почтовый индекс",
    country: "Выберите страну",
    republic: "Введите республику",
    territory: "Введите край",
    region: "Введите область",
    districts: "Введите район",
    locality: "Введите населённый пункт",
    street: "Введите улицу",
    houseNumber: "Введите номер дома",
    building: "Введите корпус",
    roomType: "Укажите тип помещения",
    roomNumber: "Введите номер помещения",
    latitude: "Укажите широту",
    longitude: "Укажите долготу",
    additionalInfo: "Введите дополнительную информацию",
};